"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /**
         * Handles the process of popping out a new window.
         * @remarks Manages the entire poput process, including closing the form from its current window,
         * opening a new browser window and initializing the bootstraping process, and reloading the form and sending it to the newly opened window.
         * @internal
         */
        // tslint:disable-next-line:class-name
        var _WindowManager = /** @class */ (function () {
            function _WindowManager() {
                var _this = this;
                this.isPoppingOut = false;
                this.channelsToFlush = 0;
                this.channelIdToSubscription = {};
                this._focusedWindowId = 0;
                this.currentRootId = 0;
                this._nextWindowId = 0;
                this.windows = {};
                this.windowCount = $dyn.observable(0);
                this._currentReserializedForms = {};
                this.windowCountToClose = 0;
                this.windowClosedCompleted = 0;
                this.windowCloseSuccess = true;
                this.windowCloseSuccessCallback = null;
                this.windowCloseErrorCallback = null;
                this._windowLoadTimeout = 10 * 1000; // 10 seconds
                /**
                 * Handler that listens for postMessage events and reacts accordingly if it is for the desired class.
                 * @remarks All PostMessage event handlers should ensure the following:
                 * 1. The `event.origin` is from the same location
                 * 2. The `event.data` is of the type we are expecting
                 * 3. The data contains some sort of unique identifier which our handler knows to look for and will not process if not found.
                 * @param event The message to handle
                 * @internal
                 */
                this.handleMessages = function (event) {
                    if (event.origin !== $dyn.util.getOrigin($dyn.util.location.location)) {
                        // Do not allow communication if it is cross origin.
                        return;
                    }
                    var options = event.data;
                    // Sanity check. Ensure these are coming for the WindowManager
                    if (typeof options === "object" && options.source === "WindowManager") {
                        options.newWindow = event.source;
                        _this.Commands[options.commandName].call(_this, options);
                    }
                };
            }
            Object.defineProperty(_WindowManager.prototype, "_interactionManager", {
                get: function () {
                    // WindowManager always exists on the host, so this always maps to the full InteractionManager
                    return $dyn.serverForm.interactionManager;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Gets the next available ID for a window
             */
            _WindowManager.prototype.getNextWindowId = function () {
                return this._nextWindowId++;
            };
            /**
             * Run before a window is actually popped out
             * @param options Options object
             */
            _WindowManager.prototype.prePopout = function (options) {
                var rootId = options.rootId;
                if (!rootId || this.isPoppingOut) {
                    return false;
                }
                this.isPoppingOut = true;
                this.currentRootId = rootId;
                if (!this._interactionManager.hasQueuedInteractions()) {
                    // If all interaction queues are empty, go ahead and popout
                    this.popoutForm();
                }
                else {
                    // If there are interactions in any queues, flush those interaction queues and wait for response.
                    // Find out which channels have interactions
                    var channelPool = this._interactionManager._channelPool;
                    // Subscribe to those channels' onInteractionsReceived events
                    for (var i = channelPool.length - 1; i >= 0; i--) {
                        var channel = channelPool[i];
                        if (channel.interactionQueue.length > 0) {
                            var subscriptionId = channel.interactionReceived.subscribe(this.onChannelFlush.bind(this));
                            this.channelIdToSubscription[channel.channel.channelId] = subscriptionId;
                            this.channelsToFlush++;
                        }
                    }
                    // Flush the channels we have subscribed to
                    this._interactionManager.flushAllChannels();
                }
                return true;
            };
            /** @internal */
            _WindowManager.prototype.onChannelFlush = function (args) {
                var _this = this;
                if (args) {
                    var channel = args.Channel;
                    var subscriptionId = this.channelIdToSubscription[channel.channel.channelId];
                    if (!subscriptionId) {
                        $dyn.log.server && $dyn.log.server("A subscription ID is required to unsubscribe successfully.");
                    }
                    // Remove the mapping
                    delete this.channelIdToSubscription[channel.channel.channelId];
                    // Unsubscribe from the channel's interactionReceived event.
                    channel.interactionReceived.unsubscribe(subscriptionId);
                    // Decrement the number of channels we are waiting on until we can popout.
                    this.channelsToFlush--;
                    if (this.channelsToFlush === 0) {
                        // All of the channels we were waiting on have been flushed. Now wait for $dyn.async.pending before continuing.
                        // We watch for $dyn.async.pending to be 1 since we have 1 long running async operation during the popout process which is expected.
                        $.when($dyn.deferred.onTrue(function () {
                            return $dyn.value($dyn.async.pending) <= 1;
                        })).done(function () {
                            _this.popoutForm();
                        });
                    }
                }
            };
            /**
             * Pops out the current form into a new window.
             * @internal
             */
            _WindowManager.prototype.popoutForm = function () {
                var _this = this;
                $dyn.async.pending.increment("WindowManager: Popout start.");
                // Create Popup and nullcheck
                var rootId = this.currentRootId;
                var windowId = this.getNextWindowId();
                // Default window sizes
                // If 80% of the parent's width is less than the default width, use the default values.
                var popoutWidth = 700;
                var popoutHeight = 700;
                if ($dyn.parentWindow) {
                    var calculatedWidth = $($dyn.parentWindow).width() * $dyn.serverForm._popoutWindowSizePercentage;
                    if (calculatedWidth >= popoutWidth) {
                        popoutWidth = calculatedWidth;
                        popoutHeight = $($dyn.parentWindow).height() * $dyn.serverForm._popoutWindowSizePercentage;
                    }
                }
                var queryBuilder = $dyn.util.parseUrl(window.location);
                queryBuilder.query = {
                    popout: windowId,
                    rootId: rootId,
                    // tslint:disable-next-line:object-literal-sort-keys
                    newPopout: true,
                    debug: $dyn.util.location.query.debug
                };
                var popoutURL = queryBuilder.relativeUrl();
                // location=no makes the url read only
                var newWindow = this.openWindow(popoutURL, "_blank", "location=no, resizable=yes, width=" + popoutWidth + ", height=" + popoutHeight);
                if (!newWindow) {
                    this.isPoppingOut = false;
                    $dyn.async.pending.decrement("WindowManager: Popout end - Failed to open new window.");
                }
                else {
                    // Logging on focus channel as the window open event is useful for debugging issues around control focus between windows.
                    $dyn.log.focus && $dyn.log.focus("Focus: Window %s opened", windowId);
                    this._windowLoadTimeoutId = window.setTimeout(function () {
                        _this.windowLoadCallbackTimedOut();
                    }, this._windowLoadTimeout);
                }
            };
            /** @internal */
            _WindowManager.prototype.windowLoadCallback = function (options) {
                var newWindow = options.newWindow;
                var windowId = options.windowId;
                var rootId = options.rootId;
                // clear the _windowLoadTimeoutId
                if (this._windowLoadTimeoutId) {
                    clearTimeout(this._windowLoadTimeoutId);
                }
                $dyn.log.navigation && $dyn.log.navigation("WindowManager: windowLoadCallback called from windowId:%s and rootId:%s", windowId, rootId);
                this.windows[windowId] = newWindow;
                this.incrementWindowCount();
                var interactionManager = this._interactionManager;
                var interactionHandler = new $dyn.serverForm.InteractionHandlerProxy(newWindow);
                interactionManager.addWindowHandler(windowId, interactionHandler);
                if (rootId) {
                    // Store the originalWindowId which is returned in case part of the popout sequence fails later on so it can be reverted.
                    var originalWindowId = interactionManager.getWindowIdFromRootId(rootId);
                    interactionManager._prepFormForPopout(rootId, originalWindowId);
                    // Call interactionManger to reroute the rootId to the newly created popout windowId.
                    interactionManager.addRootId(rootId, windowId);
                    // Transfer user settings to the new window.
                    this.transferUserSettings(windowId);
                    // Transfer shell settings to the new window.
                    this.transferShellSettings(windowId);
                    // Tell the new window to reserialize the form it is to load.
                    if (interactionHandler.reserializeForm(rootId)) {
                        $dyn.async.pending.increment("WindowManager: Reserialize form " + rootId + " start.");
                        this._currentReserializedForms[rootId] = {
                            originalWindowId: originalWindowId,
                            windowId: windowId,
                        };
                    }
                    else {
                        $dyn.log.navigation && $dyn.log.navigation("WindowManager: reserializeForm failed. See previously logged errors in the console.");
                        // Unable to reserialize form. Revert mapping and restore form to it's rightful window.
                        interactionManager.addRootId(rootId, originalWindowId);
                        this.isPoppingOut = false;
                        $dyn.async.pending.decrement("WindowManager: Popout end - Failed to open new window successfully.");
                        return;
                    }
                }
                this.isPoppingOut = false;
                $dyn.async.pending.decrement("WindowManager: Popout end - Opened new window successfully.");
            };
            /**
             * @internal
             * @param options The root ID of the reserialized form or an options object containing the root ID
             */
            _WindowManager.prototype.notifyFormReserialized = function (options) {
                var rootId = options.rootId ? options.rootId : options;
                var originalWindowId = this._currentReserializedForms[rootId].originalWindowId;
                // Call delete of the rootID on the interactionHandler from which this form originated.
                $dyn.async.pending.increment("WindowManager: Detach form " + rootId + " from window " + originalWindowId);
                if (!this._interactionManager.detachFormForPopout(rootId, originalWindowId)) {
                    $dyn.async.pending.decrement("WindowManager: Detach form " + rootId + " from window " + originalWindowId + " failed.");
                }
                delete this._currentReserializedForms[rootId];
                $dyn.async.pending.decrement("WindowManager: Reserialize form " + rootId + " finished.");
            };
            /**
             * @internal
             * @param options The root ID of the detached form or an options object containing the root ID
             */
            _WindowManager.prototype.notifyFormDetached = function (options) {
                var rootId = options.rootId ? options.rootId : options;
                $dyn.async.pending.decrement("WindowManager: Detach form " + rootId + " finished.");
            };
            /**
             * Determines if the current window is focused.
             * @internal
             */
            _WindowManager.prototype.isFocused = function () {
                return this._focusedWindowId === $dyn.serverForm._windowId;
            };
            /**
             * Called when this window gets focus
             * @remarks Called from window.focus event to notify this popout window manager that it has received focus.
             * @internal
             */
            _WindowManager.prototype.focusWindow = function () {
                this.notifyFocusWindow({ id: $dyn.serverForm._windowId });
            };
            /**
             * Callback method for when another window has received focus
             * @remarks Notification handler used by popout windows to tell the parent window (this window manager)
             * that the popout has to broadcast this notification out to all popouts in case there are multiple.
             * @internal
             */
            _WindowManager.prototype.notifyFocusWindow = function (options) {
                this._focusedWindowId = options.id;
                this._broadcastFocusWindow(options.id);
            };
            /**
             * Handler for bringing the user's settings into the new window
             * @internal
             * @param id ID of the window to transfer settings to
             */
            _WindowManager.prototype.transferUserSettings = function (id) {
                var packedUserSettings = $dyn.user().pack();
                var childWindow = this.windows[id];
                if (childWindow) {
                    var options_1 = {
                        commandName: $dyn.serverForm._WindowManagerFunction.transferUserSettings,
                        packedUserSettings: packedUserSettings,
                        source: "WindowManagerPopout",
                    };
                    $dyn.postMessage(childWindow, { data: options_1 });
                }
            };
            /**
             * Handler for bringing the shell settings into the new window
             * @internal
             * @param id ID of the window to transfer settings to
             */
            _WindowManager.prototype.transferShellSettings = function (id) {
                var packedShellSettings = $dyn.shell.pack();
                var childWindow = this.windows[id];
                if (childWindow) {
                    var options_2 = {
                        commandName: $dyn.serverForm._WindowManagerFunction.transferShellSettings,
                        packedShellSettings: packedShellSettings,
                        source: "WindowManagerPopout",
                    };
                    $dyn.postMessage(childWindow, { data: options_2 });
                }
            };
            /**
             * Closes the current window
             * @internal
             */
            _WindowManager.prototype.closeWindow = function (options) {
                var windowId = options && options.windowId;
                if (!windowId) {
                    // Main Window
                    $dyn.log.navigation && $dyn.log.navigation("WindowManager: closeWindow - Closing Host Window");
                    // Notify children windows that the Host is now gone.
                    $dyn.serverForm._windowManager.notifyHostClosed();
                    // Only end the session when the parent window is closed
                    $dyn.serverForm.endSession();
                }
                else {
                    // Popout Window
                    $dyn.log.navigation && $dyn.log.navigation("WindowManager: closeWindow - Closing Popout Window %s", windowId);
                    if (windowId === this._nextWindowId - 1) {
                        if (this.isPoppingOut) {
                            // Revert the isPoppingOut state
                            this.isPoppingOut = false;
                        }
                        for (var rootId in this._currentReserializedForms) {
                            if (windowId === this._currentReserializedForms[rootId].windowId) {
                                // This window has closed before it could complete reserializing its form. Notify that it failed.
                                var originalWindowId = this._currentReserializedForms[rootId].originalWindowId;
                                $dyn.async.pending.decrement("WindowManager: Reserialize form " + rootId + " failed to load on window " + windowId + ".");
                                $dyn.log.navigation && $dyn.log.navigation("WindowManager: Window %s was closed before it could finish reserializing form %s.", windowId, rootId);
                                $dyn.log.navigation && $dyn.log.navigation("WindowManager: Restoring form %s to window %s.", rootId, originalWindowId);
                                this._interactionManager.addRootId(rootId, originalWindowId);
                            }
                        }
                    }
                    if (this.windowCloseSuccessCallback) {
                        this.windowClosedCompleted++;
                        this.windowCloseSuccess = this.windowCloseSuccess && $dyn.value(options.windowCloseSuccess);
                        this.tryCallCloseCallbacks();
                    }
                    else {
                        var closeForms = options.closeForms ? true : false;
                        this._interactionManager.cleanupPopout(windowId, closeForms);
                    }
                    if ($dyn.value(options.windowCloseSuccess)) {
                        // Clean up ourselves from the WindowManager
                        this.cleanupWindow(windowId);
                    }
                }
            };
            /**
             * Sends a message to child windows that the host window is closed.
             * @internal
             */
            _WindowManager.prototype.notifyHostClosed = function () {
                this._postMessageToChildrenWindows($dyn.serverForm._WindowManagerFunction.hostClosed);
            };
            /**
             * Triggers all windows to block user input.
             * @param blockImmediate Should block immediately?
             * @param description The message to pass for blocking input
             */
            _WindowManager.prototype.notifyBlock = function (blockImmediate, description) {
                // Block the host window separately
                if (blockImmediate) {
                    $dyn.shell.blockUserInteractionNoWait(description);
                }
                else {
                    $dyn.shell.blockUserInteraction(description);
                }
                // notify block on all popped out windows
                this._postMessageToChildrenWindows($dyn.serverForm._WindowManagerFunction.globalBlocked);
            };
            /**
             * Triggers all windows to clear their blocked state.
             * @internal
             */
            _WindowManager.prototype.notifyUnBlock = function () {
                // UnBlock the host window separately
                $dyn.shell.unBlockUserInteraction();
                // notify unBlock on all popped out windows
                this._postMessageToChildrenWindows($dyn.serverForm._WindowManagerFunction.globalUnBlocked);
            };
            /**
             * Requests close from all popout windows.
             * @remarks When all windows have replied to the request close the success or error callbacks are invoked as required.
             * @param successCallback Called when all popout windows are closed without issues
             * @param errorCallback Called when any popout window was not closed due to form state
             */
            _WindowManager.prototype.requestCloseAllPopouts = function (successCallback, errorCallback) {
                this.windowCountToClose = 0;
                this.windowClosedCompleted = 0;
                this.windowCloseSuccess = true;
                this.windowCloseSuccessCallback = null;
                this.windowCloseErrorCallback = null;
                // if we are asked to not close all popouts then just return
                if ($dyn.debug.popoutKeepOpen) {
                    successCallback();
                    return;
                }
                if (typeof successCallback === "function") {
                    this.windowCloseSuccessCallback = successCallback;
                }
                else {
                    $dyn.logWarning("WindowManager:  closeAllPopouts should be called with a success callback.");
                }
                if (typeof errorCallback === "function") {
                    this.windowCloseErrorCallback = errorCallback;
                }
                else {
                    $dyn.logWarning("WindowManager:  closeAllPopouts should be called with an error callback.");
                }
                // tslint:disable-next-line:forin
                for (var windowId in this.windows) {
                    var childWindow = this.windows[windowId];
                    if (childWindow) {
                        var data = {
                            commandName: $dyn.serverForm._WindowManagerFunction.requestClosePopout,
                            source: "WindowManagerPopout",
                        };
                        if ($dyn.postMessage(childWindow, { data: data })) {
                            this.windowCountToClose++;
                        }
                    }
                }
                this.tryCallCloseCallbacks();
            };
            /**
             * Immediately forces each popout window to close
             * @internal
             */
            _WindowManager.prototype.forceCloseAllPopouts = function () {
                this._postMessageToChildrenWindows($dyn.serverForm._WindowManagerFunction.forceClosePopout);
            };
            /** @internal */
            _WindowManager.prototype.hasMultipleWindows = function () {
                // this.windows only holds references to child windows. If anything is in windows, then there is more than one window total.
                for (var i in this.windows) {
                    if (this.windows[i]) {
                        return true;
                    }
                }
                return false;
            };
            /**
             * Gets all windows for this client as an array
             * @internal JSDispatcher only
             * @returns An array containing all popped out windows and the parent window
             */
            _WindowManager.prototype.getAllWindows = function () {
                var allWindows = [$dyn.parentWindow];
                if ($dyn.value(this.windowCount)) {
                    // Added so that it could take part in observable scope
                    // tslint:disable-next-line:forin
                    for (var i in this.windows) {
                        this.windows[i] && allWindows.push(this.windows[i]);
                    }
                }
                return allWindows;
            };
            /**
             * Opens the specified URL in a new browser window.
             * @param popoutURL The URL to navigate to
             * @param name The name to give the popout page
             * @param windowOptions Options to pass when creating the window.
             * @returns A reference to the newly created window or `null` if creating it failed.
             */
            _WindowManager.prototype.openWindow = function (popoutURL, name, windowOptions) {
                return $dyn.shell.openWindow({ url: popoutURL, target: name, features: windowOptions });
            };
            _WindowManager.prototype.windowLoadCallbackTimedOut = function () {
                $dyn.log.navigation && $dyn.log.navigation("WindowManager: windowLoadCallbackTimedOut called after %d ms.", this._windowLoadTimeout);
                // The windowLoadCallback timed out, reset the async state and isPoppingOut flag of the windowManager.
                this.isPoppingOut = false;
                $dyn.async.pending.decrement("WindowManager: Popout end - New window failed to call the windowLoadCallback in a timely manner.");
            };
            /**
             * Sends a message to child windows that the specified window has recieved focus.
             * @param id The ID of the focused window
             */
            _WindowManager.prototype._broadcastFocusWindow = function (id) {
                this._postMessageToChildrenWindows($dyn.serverForm._WindowManagerFunction.notifyFocusWindow, { id: id });
            };
            /**
             * Sends the specified message to all child windows
             * @param commandName The name of the message to send
             * @param options Data to send with the message
             */
            _WindowManager.prototype._postMessageToChildrenWindows = function (commandName, options) {
                // tslint:disable-next-line:forin
                for (var windowId in this.windows) {
                    var childWindow = this.windows[windowId];
                    if (childWindow) {
                        if (!options) {
                            options = {};
                        }
                        options.source = "WindowManagerPopout";
                        (options.commandName = commandName), $dyn.postMessage(childWindow, { data: options });
                    }
                }
            };
            /**
             * Attempts to invoke the callback methods specified for windows closing.
             */
            _WindowManager.prototype.tryCallCloseCallbacks = function () {
                if (this.windowClosedCompleted === this.windowCountToClose) {
                    if (this.windowCloseSuccess) {
                        this.windowCloseSuccessCallback();
                    }
                    else {
                        this.windowCloseErrorCallback();
                    }
                    this.windowCloseSuccessCallback = null;
                    this.windowCloseErrorCallback = null;
                }
            };
            /**
             * Removes the windowId from the list of windows.
             * @param windowId The ID of the window to remove
             */
            _WindowManager.prototype.cleanupWindow = function (windowId) {
                delete this.windows[windowId];
                this.decrementWindowCount();
            };
            /** Increments the window count by one */
            _WindowManager.prototype.incrementWindowCount = function () {
                var value = $dyn.peek(this.windowCount);
                value++;
                this.windowCount(value);
            };
            /** Decrements the window count by one */
            _WindowManager.prototype.decrementWindowCount = function () {
                var value = $dyn.peek(this.windowCount);
                value--;
                this.windowCount(value);
            };
            return _WindowManager;
        }());
        serverForm._WindowManager = _WindowManager;
        _WindowManager.prototype.Commands = {
            closeWindow: $dyn.serverForm._WindowManager.prototype.closeWindow,
            notifyFocusWindow: $dyn.serverForm._WindowManager.prototype.notifyFocusWindow,
            notifyFormDetached: $dyn.serverForm._WindowManager.prototype.notifyFormDetached,
            notifyFormReserialized: $dyn.serverForm._WindowManager.prototype.notifyFormReserialized,
            prePopout: $dyn.serverForm._WindowManager.prototype.prePopout,
            windowLoadCallback: $dyn.serverForm._WindowManager.prototype.windowLoadCallback,
        };
        // Define a staic windowManager for QUnit tests.
        serverForm._windowManager = new _WindowManager();
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=WindowManager.js.map
